import axios from './providers/axios';

const dashboardService = {
    getStore(period, type, filter = null) {
        let url = `/v3/admin/dashboard/store?type=${type}&period=${period}`;

        // ✅ Filter varsa ekle
        if (filter && filter !== 'all') {
            url += `&filter=${filter}`;
        }

        return axios.get(url);
    },

    getProgramsData(period = 'lastMonth', filter = 'all') {
        return this.getStore(period, 'programs', filter);
    },

    getUsersData(period = 'lastMonth', filter = 'all') {
        return this.getStore(period, 'users', filter);
    },

    getTestsData(period = 'lastMonth') {
        return this.getStore(period, 'tests');
    },

    getExpertsData(period = 'lastMonth') {
        return this.getStore(period, 'experts');
    },

    getGameLabsData(period = 'lastMonth') {
        return this.getStore(period, 'gameLabs');
    },

    getBlogsData(period = 'lastMonth') {
        return this.getStore(period, 'blogs');
    },

    getAllDashboardData(period = 'lastMonth') {
        return Promise.allSettled([
            this.getProgramsData(period),
            this.getUsersData(period),
            this.getTestsData(period),
            this.getExpertsData(period),
            this.getGameLabsData(period),
            this.getBlogsData(period)
        ]);
    },

    mapPeriod(period) {
        const periodMap = {
            'all': 'all',
            'week': 'lastWeek',
            'month': 'lastMonth',
            'year': 'lastYear'
        };
        return periodMap[period] || 'lastMonth';
    }
};

export default dashboardService;
